module.exports = __webpack_public_path__ + "img/aarie_beleaka_yes.5e2d56c0.png";